import _ from 'lodash';
import { Component, Input } from '@angular/core';
import { ForwarderService, Region } from '../../../services/index';

@Component({
  selector: 'region-list',
  templateUrl: 'region-list.html'
})
export class RegionListComponent {
  @Input() selRegionList;
  @Input() statusCd;
  @Input() indexId;
  
  regionList: Array<Region>;
  selTabRegion: Region;

  constructor(
    private forwarderService: ForwarderService
  ) {}

  ngOnInit() {
    this.forwarderService.getRegions().subscribe(
      resp => {
        this.regionList = resp.data;
        this.selTabRegion = resp.data[0];
      }
    )
  }

  isChecked(region) {
    if(this.selRegionList) {
      for (let i = 0 ; i < this.selRegionList.length ; i++) {
        let selRegion = this.selRegionList[i];
        if (region.regionId === selRegion.regionId) { 
          return 'checked'
        }
      }
      return null;
    }
  }
  
  setSelRegionTab(region) {
    this.selTabRegion = region;
  }

  regionCheckHandler(isChecked, region) {
		let selRegionList = this.selRegionList;

		if (isChecked) {
			if (!_.find(selRegionList, ['regionId', region.regionId])) selRegionList.push(region);
			
		} else {
			_.remove(selRegionList, (target) => {
				if (region.regionId === target.regionId) return true;
				else return false;
			});
		}

		if (region.childList && region.childList.length > 0) {
			for (let i = 0 ; i < region.childList.length; i++) {
				let child = region.childList[i];
				this.regionCheckHandler(isChecked, child);
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/region-list.ts